import React, { useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import WebData from "../../../Helpers/WebData";
import Login from "../Login";
import Register from "../Register";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import "./DesktopNavbar.style.css";

const Navbar = (props) => {
  const user = localStorage.getItem("user");
  const userType = localStorage.getItem("userType");
  const [logout, setlogout] = useState(false);
  const navbar = useRef();
  const [mobileNav, setMobileNav] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e) => {
    if (!navbar.current?.contains(e.target)) {
      setMobileNav(false);
    }
  };
  window.addEventListener("mousedown", handleClick, false);

  const navigateTo = (id) => {
    if (document.getElementById(id)) {
      let offsetTop = document.getElementById(id).offsetTop;
      window.scroll({
        top: offsetTop - 60,
        behavior: "smooth",
      });
    }
  };

  window.addEventListener("scroll", () => {
    setMobileNav(false);
  });

  const logout_user = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("userMail");
    localStorage.removeItem("userType");
    localStorage.removeItem("token");
    window.location.reload();
  };

  const admin = () => {
    navigate("/admin");
    setlogout(false);
  };

  console.log(navigate);
  return (
    <>
      <nav
        className="navbar navbar-bg navbar-expand-lg fixed-top blur-background"
        id="navbar"
      >
        <div className="container">
          {location.pathname === "/" ? (
            <a
              className="navbar-brand mr-0"
              onClick={() => window.scroll(0, 0)}
            >
              Samskrithi Goshala
            </a>
          ) : (
            <Link className="navbar-brand mr-0" to="/">
              Samskrithi Goshala
            </Link>
          )}
          <div
            className="collapse navbar-collapse d-none d-lg-block"
            id="navbarScroll"
          >
            <ul className="navbar-nav ml-auto my-lg-0 ">
              {WebData.navbar.options.map((option, i) => (
                <li
                  className={"nav-item mx-1 " + (i ? "" : "active")}
                  title={option.title}
                  key={i}
                >
                  {location.pathname === "/" ? (
                    option.title === "Engage" ? (
                      <a
                        className="nav-link "
                        href={`#${option.link}`}
                        role="tab"
                        onClick={() => {
                          var elems = document.querySelectorAll(
                            "#v-pills-tab .nav-link"
                          );
                          elems.forEach((ele) => {
                            ele.classList.remove("active");
                          });
                        }}
                      >
                        {option.title}
                      </a>
                    ) : (
                      <a
                        className="nav-link "
                        href={`#${option.link}`}
                        aria-labelledby="v-pills-csr-tab"
                      >
                        {option.title}
                      </a>
                    )
                  ) : (
                    <a
                      className="nav-link "
                      onClick={() => navigate(`/#${option.link}`)}
                    >
                      {option.title}
                    </a>
                  )}
                </li>
              ))}
              <li className={"nav-item mx-1 "} title="Shop" key={8}>
                {location.pathname === "/shop" ? (
                  <a onClick={() => window.scroll(0, 0)} className="nav-link">
                    Shop
                  </a>
                ) : (
                  <Link to={"/shop"} className="nav-link">
                    Shop
                  </Link>
                )}
              </li>
            </ul>
          </div>
          <div className="icons ml-auto mr-2 pl-2 pr-md-3 pr-1">
            <a
              className="text-light d-none d-sm-inline"
              target="_blank"
              rel="noopener noreferrer"
              href={`tel:${WebData.contact.phone}`}
            >
              <i className="mx-1 fa fa-phone"></i>
            </a>
            <a
              className="text-light"
              target="_blank"
              rel="noopener noreferrer"
              href={`https://wa.me/${WebData.contact.whatsapp}`}
            >
              <i className="mx-1 fa fa-whatsapp"></i>
            </a>
            <a
              className="text-light d-none d-sm-inline"
              target="_blank"
              rel="noopener noreferrer"
              href={`https://telegram.me/${WebData.contact.telegram}`}
            >
              <i className="mx-1 fa fa-telegram"></i>
            </a>
            <a
              className="text-light"
              target="_blank"
              rel="noopener noreferrer"
              href={
                window.matchMedia("(max-width: 786px)").matches
                  ? `mailto:${WebData.contact.mail}`
                  : "https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=samskrithigoshala@gmail.com"
              }
            >
              <i className="mx-1 fa fa-envelope"></i>
            </a>
            <i
              className="fa fa-shopping-cart ml-3 text-light cursor-pointer position-relative d-inline d-sm-none cart"
              onClick={() => {
                props.handleShowCart(true);
              }}
            >
              <span className="badge badge-primary">1</span>
            </i>
          </div>
          <div className="nav-item d-none d-sm-block">
            {user ? (
              <button
                className="btn signInBtn"
                onClick={() => setlogout(!logout)}
              >
                {user}
              </button>
            ) : (
              <button
                className="btn signInBtn"
                onClick={props.handleLoginModal}
              >
                Sign In
              </button>
            )}
            <Login
              loginModal={props.loginModal}
              handleLoginModal={props.handleLoginModal}
              handleRegisterModal={props.handleRegisterModal}
              RegisterModal={props.RegisterModal}
            />
            <Register
              loginModal={props.loginModal}
              handleLoginModal={props.handleLoginModal}
              handleRegisterModal={props.handleRegisterModal}
              RegisterModal={props.RegisterModal}
            />
            <i
              className="fa fa-shopping-cart ml-3 mr-2 text-light cursor-pointer position-relative d-none d-sm-inline"
              onClick={() => {
                props.handleShowCart(true);
              }}
            >
              <span className="badge badge-primary">1</span>
            </i>
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            left: "68%",
            top: "95%",
            display: logout ? "block" : "none",
            padding: "15px 0%",
            fontSize: "15px",
            backgroundColor: "white",
            border: "3px solid black",
            borderRadius: "10px",
            paddingTop: "25px",
            cursor: "pointer",
            width: "12%",
          }}
          className="logout"
        >
          {userType === "Admin" && (
            <div key={1}>
              <p
                key={1}
                style={{ padding: "0 5%", marginLeft: "25%" }}
                onClick={admin}
              >
                <SupervisorAccountIcon /> Admin
              </p>
              <hr />
            </div>
          )}
          <p
            style={{ padding: "0 5%", marginLeft: "25%" }}
            onClick={logout_user}
          >
            <PowerSettingsNewIcon /> Log Out
          </p>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
